import React from "react";
import { notification, Row } from "antd";
import { NOTIFICATION_TYPE } from "@/config/constants";
import { lightTheme } from "@/themes/ThemeConfig";
import { RATypography } from "@/components/customs";
import { SvgClose, SvgErrorFill, SvgInfoFill, SvgSuccessFill, SvgWarningFill } from "@/assets/icons";

export const toast = ({ type, description }) => {
	const configStyle = {
		boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.06)",
		borderRadius: 12,
		padding: "16px 24px",
	};

	switch (type) {
		case NOTIFICATION_TYPE.SUCCESS:
			notification.success({
				message: (
					<RATypography variant="label1" color={lightTheme.color_status_success_500}>
						SUCCESS
					</RATypography>
				),
				description: (
					<RATypography variant="body3" top={-4} color={lightTheme.color_status_success_500}>
						{description}
					</RATypography>
				),
				icon: (
					<Row align="middle" justify="center" style={{ width: 22, height: 22 }}>
						<SvgSuccessFill />
					</Row>
				),
				style: {
					backgroundColor: "#ECFDF5",
					borderLeftColor: lightTheme.color_status_success_500,
					...configStyle,
				},
				closeIcon: <SvgClose />,
			});
			break;
		case NOTIFICATION_TYPE.INFO:
			notification.info({
				message: (
					<RATypography variant="label1" color={lightTheme.color_status_info_500}>
						INFO
					</RATypography>
				),
				description: (
					<RATypography variant="body3" top={-4} color={lightTheme.color_status_info_500}>
						{description}
					</RATypography>
				),
				icon: (
					<Row align="middle" justify="center" style={{ width: 22, height: 22 }}>
						<SvgInfoFill />
					</Row>
				),
				style: {
					backgroundColor: "#EEF3FF",
					borderLeftColor: lightTheme.color_status_info_500,
					...configStyle,
				},
				closeIcon: <SvgClose />,
			});
			break;
		case NOTIFICATION_TYPE.ERROR:
			notification.error({
				message: (
					<RATypography variant="label1" color={lightTheme.color_status_error_500}>
						ERROR
					</RATypography>
				),
				description: (
					<RATypography variant="body3" top={-4} color={lightTheme.color_status_error_500}>
						{description}
					</RATypography>
				),
				icon: (
					<Row align="middle" justify="center" style={{ width: 22, height: 22 }}>
						<SvgErrorFill />
					</Row>
				),
				style: {
					backgroundColor: "#FFF2F2",
					borderLeftColor: lightTheme.color_status_error_500,
					...configStyle,
				},
				closeIcon: <SvgClose />,
			});
			break;
		case NOTIFICATION_TYPE.WARNING:
			notification.warning({
				message: (
					<RATypography variant="label1" color={lightTheme.color_primary_500}>
						WARNING
					</RATypography>
				),
				description: (
					<RATypography variant="body3" top={-4} color={lightTheme.color_primary_500}>
						{description}
					</RATypography>
				),
				icon: (
					<Row align="middle" justify="center" style={{ width: 22, height: 22 }}>
						<SvgWarningFill />
					</Row>
				),
				style: {
					backgroundColor: "#FFF9EB",
					borderLeftColor: lightTheme.color_primary_500,
					...configStyle,
				},
				closeIcon: <SvgClose />,
			});
			break;
		default:
			notification.warning({
				message: (
					<RATypography variant="label1" color={lightTheme.color_primary_500}>
						WARNING
					</RATypography>
				),
				description: (
					<RATypography variant="body3" top={-4} color={lightTheme.color_primary_500}>
						{description}
					</RATypography>
				),
				icon: (
					<Row align="middle" justify="center" style={{ width: 22, height: 22 }}>
						<SvgWarningFill />
					</Row>
				),
				style: {
					backgroundColor: "#FFF9EB",
					borderLeftColor: lightTheme.color_primary_500,
					...configStyle,
				},
				closeIcon: <SvgClose />,
			});
			break;
	}
};
